import { render } from "./TariffExposureView.vue?vue&type=template&id=6b8d0af5&scoped=true"
import script from "./TariffExposureView.vue?vue&type=script&lang=js"
export * from "./TariffExposureView.vue?vue&type=script&lang=js"

import "./TariffExposureView.vue?vue&type=style&index=0&id=6b8d0af5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b8d0af5"]])

export default __exports__